import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import CloseBigIcon from "../../../assets/common/close_big.svg"

const Modal = (props) => {
    const {
        title: modalTitle,
        actionTitle: actionButtonTitle,
        closeTitle: closeButtonTitle,
        children: childComponent,
        onAction: onHandleAction,
        onClose: onHandleClose,
        saveAsTitle,
        onActionSave,
        customChildCssClass,
        displayMultiPopup,
        disableApproveRejectButton,
        bottomButtonNotNeed=false,
        customeClassParent,
        WrapperClass,
        modalWithDetail =false,
        isDoubleModal,
        permissionDetails,
        isEditWorkListApproval,
        isView=false,
        isModalFooterSticky = true,
        displayScroll = false,
        isFocusModal = true
    } = props
    const { t } = useTranslation()
    const modalRef = useRef(null)

    useEffect(() =>{
        const modalElement = modalRef?.current
        const focusableElements = modalElement?.querySelectorAll(
            "a, button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])"
        )
            
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements?.length - 1]
        if(isFocusModal && firstElement){
            firstElement?.focus()
        }
        const handleTabKeyPress = (event) => {
            if (event?.key === "Tab") {
                if (event?.shiftKey && document?.activeElement === firstElement) {
                    event?.preventDefault()
                    lastElement?.focus()
                } else if (
                    !event?.shiftKey &&
                    document?.activeElement === lastElement
                ) {
                    event?.preventDefault()
                    firstElement?.focus()
                }
            }
        }
        
        modalElement.addEventListener("keydown", handleTabKeyPress)
        if(!displayScroll)
            document.body.style.overflow = "hidden"

        return () => {
            document.body.style.overflow = ""
            modalElement.removeEventListener("keydown", handleTabKeyPress)
        }
    },[])
    

    const MODAL_CLASS =`h-full w-full fixed left-0 top-0 overflow-x-hidden overflow-y-hidden 
    inset-0 outline-none focus:outline-none z-[11]`
    return (
        <div
            className={ `${!isDoubleModal && MODAL_CLASS} ${customeClassParent} h-auto
            ${props?.sliderClass ? props?.sliderClass : ""}` }
            ref={ modalRef }
        >
            
            <div
                className={ `${props.sliderClassTransition} ${WrapperClass ? WrapperClass : isEditWorkListApproval 
                    ? "max-w-[80%]" : "max-w-[866px]"} ${customChildCssClass} absolute 
                right-0 h-full w-full  z-100 overflow-auto  ` }  
            >
                <div className={ `${isModalFooterSticky ? "pb-0": ""} ${props?.contentClass} h-full w-full 
                    border-0 rounded-lg shadow-lg px-4 py-3 
                relative flex 
                    flex-col bg-white outline-none focus:outline-none z-100 overflow-auto modal-content 
                    ${modalWithDetail && "px-0 py-0 rounded-0 "} ${modalWithDetail && "!bg-lighestgray"}` } id="custom_modal">
                    <div className={ `flex flex-row ${modalWithDetail && "px-[48px]"}` }>
                        <div className="w-3/4 flex items-center" >
                            <button >
                                <h1 className={ `text-2xl font-black text-primary-50 ${props?.titleClass}` }>
                                    { modalTitle }
                                </h1>
                            </button>
                            { props?.notificationCount > -1 && (
                                <>
                                    <div className="flex gap-[10px] flex-col 
                                      w-[30px] h-[20px] justify-center rounded-full 
                                      background bg-tertiary-500 border solid border-white ml-[10px] items-center">
                                        <span className="text-white text-xs font-bolder text-right w-fit pt-[2px]">
                                            { props.notificationCount }
                                        </span>
                                    </div>
                                </>
                            ) }
                        </div>
                        { props.isCloseOnTop && (
                            <div className="w-1/4 flex flex-row-reverse">
                                <button type="button" onClick={ props.onTopClose }>
                                    <img
                                        alt="close"
                                        src={ CloseBigIcon }
                                        height={ "16px" }
                                        width={ "16px" }
                                    ></img>
                                </button>
                            </div>
                        ) }
                    </div>
                    <div className="flex flex-col">
                        
                    </div>
                    <div className={ `relative flex-auto h-100 ${modalWithDetail && "px-[48px]"}` }>
                        { childComponent }</div>
                    {
                        !bottomButtonNotNeed && ( (permissionDetails?._read && !permissionDetails?._delete 
                            && !permissionDetails?._write && !permissionDetails?._update) ? <> </> 

                            :
                            <div className={ `flex items-center gap-4 ${props.buttonClass ? 
                                props.buttonClass : "justify-end p-4"} ${isModalFooterSticky ?
                                "sticky border-y border-primary-300 pt-2 pb-2 bg-white bottom-0 mt-2" : ""}` }>
                                    
                                { (closeButtonTitle || props.additionalActionTitle || actionButtonTitle) && (
                                    <>
                                        <button
                                            className="text-blue bg-white border border-solid 
                                                hover:border-primary-150 
                                                hover:bg-primary-150 border-primary-50 
                                                font-bold text-base px-6 py-3 
                                                outline-none 
                                                focus:outline-1 focus:outline-black focus:outline-offset-2 
                                                
                                                rounded-full disabled:bg-primary-300 disabled:text-secondary-50 
                                                disabled:border-0"
                                            type="button"
                                            tabIndex={ 0 }
                                            onClick={ onHandleClose }
                                            disabled={ props.CloseButtonDisabled || false }
                                        >
                                            { props?.closeTitle ? closeButtonTitle : t("common.cancel") }
                                        </button>
                                    </>
                                ) }
                                { props.additionalActionTitle ? (
                                    <button
                                        className="bg-white border border-solid 
                                            hover:border-0 hover:bg-tertiary-50 hover:text-white 
                                            border-tertiary-50 
                                            font-bold text-tertiary-50 px-6 py-3 outline-none 
                                            
                                            focus:outline-1 focus:outline-black focus:outline-offset-2 rounded-full"
                                        type="button"
                                        disabled={ disableApproveRejectButton }
                                        tabIndex={ 0 }
                                        onClick={ props.onAdditionalAction }
                                    >
                                        { props.additionalActionTitle }
                                    </button>
                                ) : (
                                    <></>
                                ) }

                                { saveAsTitle && (
                                    <button
                                        disabled={ isView }
                                        className="text-blue bg-white border border-solid 
                                    hover:border-primary-150 
                                    hover:bg-primary-150 border-primary-50 
                                    font-bold text-base px-6 py-3 
                                    outline-none 
                                    focus:outline-1 focus:outline-black focus:outline-offset-2 
                                    
                                    rounded-full disabled:bg-primary-300 disabled:text-secondary-50 
                                    disabled:border-0" type="button"
                                        tabIndex={ 0 }
                                        onClick={ (e) => {
                                            e.stopPropagation()
                                            e.nativeEvent.stopImmediatePropagation()
                                            onActionSave(e)
                                        } }
                                    >
                                        { saveAsTitle }
                                    </button>
                                ) }
                                { actionButtonTitle && (
                                    <button
                                        className="text-white border border-solid hover:border-primary-150 
                                        bg-primary-100 hover:bg-primary-150 border-primary-50 hover:text-primary-50 
                                        font-bold text-base px-6 py-3 outline-none focus:outline-1 
                                        focus:outline-black focus:outline-offset-2 rounded-full 
                                        disabled:bg-primary-300 disabled:text-secondary-50 disabled:border-0"
                                        type="button"
                                        tabIndex={ 0 }
                                        disabled={ disableApproveRejectButton || isView }
                                        onClick={ (e) => {
                                            e.stopPropagation()
                                            e.nativeEvent.stopImmediatePropagation()
                                            onHandleAction(e)
                                        } }
                                    >
                                        { props?.actionTitle
                                            ? t(`${actionButtonTitle}`)
                                            : t("common.submit") }
                                    </button>
                                ) }
                                    
                                
                            </div>)
                    }
                </div>
            </div>
           
            <div
                className={ `${
                    displayMultiPopup
                        ? ""
                        : `h-full w-full flex justify-center items-center overflow-x-hidden 
                        bg-secondary-50 opacity-50 overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none`
                }` }
            ></div>
        </div>
    )
}

Modal.propTypes = {
    WrapperClass: PropTypes.string.isRequired,
    actionTitle: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    closeTitle: PropTypes.string.isRequired,
    customChildCssClass: PropTypes.string.isRequired,
    disableApproveRejectButton: PropTypes.bool.isRequired,
    displayMultiPopup: PropTypes.bool.isRequired,
    onAction: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
}

export default Modal
